//用户中心
export default [
    {
        alias: '',
        path: 'userCenter',
        name: 'userCenter',
        meta: {
            title: '用户中心',
            icon: 'userCenter'
        },
        hidden: false,
        component: () => import("@/views/user/userCenter/index.vue"),
        children: [{
            alias: '',
            path: 'userList',
            name: 'userList',
            meta: {
                title: '用户列表',
                icon: 'userList'
            },
            hidden: false,
            component: () => import("@/views/user/userCenter/userList.vue"),
        },
        {
            path: 'feedback',
            name: 'feedback',
            meta: {
                title: '意见反馈',
                icon: 'feedback'
            },
            hidden: false,
            component: () => import("@/views/user/userCenter/feedback.vue"),
        },{
            path: 'verifyList',
            name: 'verifyList',
            meta: {
                title: '验证码',
                icon: 'verifyList'
            },
            hidden: false,
            component: () => import("@/views/user/userCenter/verifyList.vue"),
        },{
            path: 'userInfo',
            name: 'userInfo',
            meta: {
                title: '用户详情',
                icon: 'userInfo'
            },
            hidden: true,
            component: () => import("@/views/user/userCenter/userInfo.vue"),
        }]
    }

]